import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import type { RecruitmentShowApplicationsSubProps as Props } from './types';
import type { Recruitment } from '../../../types/recruitmentShow';
import { showRecruitmentPageRecruitments } from '../../../services/recruitments';

export const Component: FunctionComponent<Props> = (props) => {
  const [applications, setApplications] = useState<Recruitment[]>([]);

  useEffect(() => {
    const request = async () => {
      try {
        const response = await showRecruitmentPageRecruitments(props.recruitmentId);
        setApplications(response.recruitments);
      } catch (error) {
        console.log(error);
      }
    };
    request();
  }, [props.recruitmentId]);

  useEffect(() => {
    const $slider = $('.js-recruitment-applications-sub');
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '0',
        variableWidth: true,
        autoplay: false,
        prevArrow: '<div class="recruitment__show__company__slider--prev"></div>',
        nextArrow: '<div class="recruitment__show__company__slider--next"></div>',
        responsive: [
          {
            breakpoint: 929,
            settings: {
              arrows: false
            }
          }
        ]
      })
    }
  }, [applications]);

  return (
    <Presentation
      {...props}
      applications={applications}
    />
  );
};
